export const mockMessages = [
  {
    id: 1747291167001,
    sender: 'bot',
    text: `La división es una operación matemática que consiste en repartir un número (llamado dividendo) en partes iguales, según otro número (llamado divisor). El resultado de la división se llama cociente. 
  
  La división se puede expresar de la siguiente manera:
  
  $$ \\text{Dividendo} \\div \\text{Divisor} = \\text{Cociente} $$
  
  $$ \\sqrt{44} $$
  
  Por ejemplo, si tenemos 12 manzanas (dividendo) y las queremos repartir entre 3 amigos (divisor), cada amigo recibiría 4 manzanas (cociente).
  
  Aquí tienes un diagrama simple:
  
  \`\`\`
     12 (Dividendo)
     ──────────────
  3 | 4 (Cociente)
  \`\`\`
  
  En este diagrama, 12 se divide entre 3, y el resultado es 4. 
  
  Si deseas más ejemplos o ejercicios sobre la división, no dudes en pedírmelo.`,
    // text: 'La división es una operación aritmética que consiste en repartir una cantidad en partes iguales. En términos simples, se busca saber cuántas veces un número (divisor) está contenido en otro número (dividendo).Aquí tienes los componentes principales de una división:- **Dividendo**: el número que se va a dividir.- **Divisor**: el número entre el cual se divide.- **Cociente**: el resultado de la división.- **Residuo**: lo que sobra después de dividir si no se puede repartir de manera exacta.Un diagrama simple para ilustrar la división podría ser el siguiente:```    Dividendo ______Divisor | Cociente```Por ejemplo, si dividimos 12 entre 3:```12  _____3 | 4```En este caso:- **Dividendo** = 12- **Divisor** = 3- **Cociente** = 4- **Residuo** = 0 (no hay sobrante)Si necesitas más información o ejemplos sobre la división, ¡házmelo saber!',
    timestamp: '2025-05-15T06:39:32.755Z',
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/home',
      timestamp: '2025-05-15T06:39:27.115Z',
    },
  },
  {
    id: 1747291167002,
    sender: 'bot',
    text: `No puedo crear diagramas visuales directamente, pero puedo proporcionarte el código en formato Mermaid que puedes usar en un entorno que soporte esta sintaxis. Aquí tienes un ejemplo de un diagrama de flujo simple:
  
  \`\`\`mermaid
  graph TD;
      A[Inicio] --> B{¿Condición?};
      B -- Sí --> C[Acción 1];
      B -- No --> D[Acción 2];
      C --> E[Fin];
      D --> E;
  \`\`\`
  
  Puedes copiar este código y pegarlo en un editor que soporte Mermaid, como algunos editores de Markdown o herramientas en línea. Si necesitas un tipo diferente de diagrama o más detalles, ¡avísame!`,
    timestamp: '2025-05-15T06:39:32.755Z',
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/home',
      timestamp: '2025-05-15T06:39:27.115Z',
    },
  },
  {
    id: 1747291167003,
    sender: 'bot',
    text: `Claro, la fórmula para calcular la raíz cuadrada de un número ( x ) se expresa como:
  
  \\[
  \\sqrt{x}
  \\]
  
  Esto significa que la raíz cuadrada de ( x ) es el número que, al ser multiplicado por sí mismo, da como resultado ( x ). Por ejemplo, ( sqrt{9} = 3 ) porque ( 3 times 3 = 9 ). Si necesitas más información o ejemplos sobre raíces cuadradas, ¡házmelo saber!`,
    timestamp: '2025-05-15T06:39:32.755Z',
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/home',
      timestamp: '2025-05-15T06:39:27.115Z',
    },
  },
  {
    id: 1747291167004,
    sender: 'bot',
    text: `Aquí una lista:
    
  Por ejemplo, en la división 12 ÷ 3:

  - Dividendo: 12
  - Divisor: 3
  - Cociente: 4
  - Residuo: 0 (en este caso, 12 es divisible por 3 sin sobras)
    
  Aquí tienes un ejemplo básico de una función en JavaScript que suma dos números:
  
  \`\`\`javascript
  function sumar(num1, num2) {
      return num1 + num2;
  }
  
  // Ejemplo de uso:
  let resultado = sumar(5, 3);
  console.log(resultado); // Esto mostrará 8 en la consola
  \`\`\`
  
  En este código, la función \`sumar\` toma dos parámetros (\`num1\` y \`num2\`), los suma y devuelve el resultado. Luego, se muestra un ejemplo de cómo usar la función. Si tienes más preguntas o necesitas más ejemplos, ¡dímelo!`,
    timestamp: '2025-05-15T06:39:32.755Z',
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/home',
      timestamp: '2025-05-15T06:39:27.115Z',
    },
  },
  {
    id: 1747291167005,
    sender: 'bot',
    text: `La división es una operación matemática que consiste en separar un número, llamado dividendo, en partes iguales según otro número, llamado divisor. El resultado de una división se llama cociente. Si hay un residuo, se llama residuo.

Por ejemplo, en la división 12 ÷ 3:

- Dividendo: 12
- Divisor: 3
- Cociente: 4
- Residuo: 0 (en este caso, 12 es divisible por 3 sin sobras)

Para hacer un diagrama sencillo, imagina que tienes 12 manzanas y quieres repartirlas entre 3 amigos:

\`\`\`
12 manzanas
 ┌─────────┬─────────┬─────────┐
 │ Amigo 1 │ Amigo 2 │ Amigo 3 │
 └─────────┴─────────┴─────────┘
     4         4         4
\`\`\`

Cada amigo recibe 4 manzanas.

Si necesitas más información o ejemplos sobre este tema, ¡no dudes en preguntar!`,
    timestamp: '2025-05-15T06:39:32.755Z',
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/home',
      timestamp: '2025-05-15T06:39:27.115Z',
    },
  },
  {
    id: 123,
    sender: 'bot',
    text: `Aquí tienes el diagrama sobre la división:

\`\`\`mermaid
mindmap
  root((División))
    Componentes
      Dividendo
      Divisor
      Cociente
    Representación
      Fracción
      Símbolo '÷'
      Barra (/)
    Tipos
      División exacta
      División inexacta
      División de enteros
    Propiedades
      Propiedad del cociente
      Propiedad de la multiplicación inversa
\`\`\`

Este diagrama muestra los componentes, representaciones, tipos y propiedades de la división.`,
    timestamp: '2025-05-15T06:39:32.755Z',
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/home',
      timestamp: '2025-05-15T06:39:27.115Z',
    },
  },
  {
    id: 124,
    sender: 'bot',
    text: '1 Aquí tienes un diagrama sobre los números naturales:\n\n```mermaid\n\nmindmap\n\n  root((Números Naturales))\n\n    subtopic1((Definición))\n\n      detail1((Uso para contar y ordenar))\n\n      detail2((Enteros no negativos))\n\n    subtopic2((Representación))\n\n      detail1((Símbolo: N))\n\n    subtopic3((Características))\n\n      detail1((Infinitos))\n\n      detail2((No incluyen fracciones))\n\n      detail3((No incluyen decimales))\n\n    subtopic4((Aplicaciones))\n\n      detail1((Matemáticas))\n\n      detail2((Vida cotidiana))\n\n```\n\nEste diagrama resume la definición, representación, características y aplicaciones de los números naturales.',
    timestamp: '2025-05-15T06:39:32.755Z',
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/home',
      timestamp: '2025-05-15T06:39:27.115Z',
    },
  },
  {
    id: 126,
    sender: 'bot',
    text: '2 Aquí tienes un diagrama de los números naturales:\n\n```mermaid\nmindmap\n  root((Números Naturales))\n    Concepto((Definición))\n      Contar((Usados para contar y ordenar))\n    Conjunto((Conjunto $$\\mathbb{N}$$))\n      Incluye((Incluye números))\n        Números((Números enteros positivos))\n        Cero((Puede incluir 0 en algunas definiciones))\n    Características((Características))\n      Infinitos((Conjunto infinito))\n      Negativos((No incluye números negativos))\n      Fracciones((No incluye fracciones))\n    Ejemplos((Ejemplo de números))\n      N1((1))\n      N2((2))\n      N3((3))\n      N4((4))\n      N5((5))\n```\n\nPuedes visualizarlo en un entorno que soporte diagramas de Mermaid. Si necesitas más información o detalles, ¡házmelo saber!',
    timestamp: '2025-05-15T06:39:32.755Z',
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/home',
      timestamp: '2025-05-15T06:39:27.115Z',
    },
  },
  {
    id: 127,
    sender: 'bot',
    text: '2 Aquí tienes un diagrama de los números naturales:\n\n```mermaid\n graph LR\n      A["$$x^2$$"] -->|"$$\\sqrt{x+3}$$"| B("$$\\frac{1}{2}$$")\n      A -->|"$$\\overbrace{a+b+c}^{\text{note}}$$"| C("$$\\pi r^2$$")\n      B --> D("$$x = \\begin{cases} a &\\text{if } b \\\\ c &\\text{if } d \\end{cases}$$")\n\n     C --> E("$$x(t)=c_1\\begin{bmatrix}-\\cos{t}+\\sin{t}\\ 2\\cos{t} \\end{bmatrix}e^{2t}$$")\n```\n\nPuedes visualizarlo en un entorno que soporte diagramas de Mermaid. Si necesitas más información o detalles, ¡házmelo saber!',
    timestamp: '2025-05-15T06:39:32.755Z',
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/home',
      timestamp: '2025-05-15T06:39:27.115Z',
    },
  },
  {
    id: 128,
    sender: 'bot',
    text: '¡Qué buena pregunta! 😎  \nUna **recta numérica** es una línea donde colocamos los números en orden, desde los negativos hasta los positivos. \n    Nos ayuda a entender operaciones como sumar, restar, y comparar valores.\n   Aquí tienes un ejemplo de una recta numérica que va de **−5 a 5**:\n ```mermaid\n    graph LR\n    -5((−5)) --> -4((−4)) --> -3((−3)) --> -2((−2)) --> -1((−1)) --> 0((0)) --> 1((1)) --> 2((2)) --> 3((3)) --> 4((4)) --> 5((5))\n   ```\n\n    Fíjate que el **cero** está en el centro. A la izquierda están los números negativos y a la derecha los positivos.  \n\n¿Quieres que veamos cómo sumar o restar usando esta recta? ➕➖',
    timestamp: '2025-05-15T06:39:32.755Z',
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/home',
      timestamp: '2025-05-15T06:39:27.115Z',
    },
  },
];

// 🚀 Mock para mostrar processing tools y tarjetas de visualización
export const mockMessageWithToolsAndCards = {
  // Mensaje principal con contenido que genera tarjetas
  message: {
    id: 1747291167010,
    sender: 'bot',
    text:
      `Estoy analizando los datos y generando visualizaciones para ti...

Aquí tienes un diagrama de flujo del proceso de análisis:

[MERMAID_DIAGRAM]
graph TD
    A[Inicio del análisis] --> B{¿Datos válidos?}
    B -->|Sí| C[Procesamiento]
    B -->|No| D[Error de validación]
    C --> E[Generación de gráficos]
    E --> F[Visualización D3]
    F --> G[Resultado final]
    D --> H[Solicitar nuevos datos]
[/MERMAID_DIAGRAM]

También he preparado una visualización interactiva con los resultados del análisis:

[Visualización interactiva de potencias](https://widget.app-ai-dev.oneclicklabs.es/visualizations/d3/4eb05fbb-ce2b-4f8d-b216-e39688caface.html)

Otro formato de interactivo: 

[D3_VISUALIZATION][Visualización interactiva de potencias](https://widget.app-ai-dev.oneclicklabs.es/visualizations/d3/4eb05fbb-ce2b-4f8d-b216-e39688caface.html)[/D3_VISUALIZATION]

Los datos muestran tendencias interesantes que puedes explorar en la visualización interactiva.

` +
      'Las **funciones logarítmicas** son un tipo especial de función matemática que se define como la inversa de una función exponencial. Su forma general es:\n\n$$f(x) = \\log_a x$$\n\nDonde:\n- **\\(a\\)** es la base del logaritmo, un número positivo distinto de 1 $a > 0$ y \\(a \\neq 1\\)).\n- **\\(x\\)** es la variable, que debe ser mayor que 0 (\\(x > 0\\)).\n\n### ¿Qué significa un logaritmo?\nEl logaritmo responde a la pregunta: **¿a qué exponente debo elevar la base \\(a\\) para obtener \\(x\\)?**  \nPor ejemplo:\n- Si \\(f(49) = \\log_7 49 = 2\\), esto significa que \\(7^2 = 49\\).\n\n### Características principales:\n1. **Dominio**: El conjunto de valores posibles para \\(x\\) es \\((0, \\infty)\\).\n2. **Rango**: Los valores de \\(f(x)\\) pueden ser cualquier número real (\\(\\mathbb{R}\\)).\n3. **Intercepto en el eje X**: La gráfica pasa por el punto \\((1, 0)\\), ya que \\(\\log_a 1 = 0\\).\n4. **Intercepto en el eje Y**: No existe, porque la función tiene una asíntota vertical en \\(x = 0\\).\n5. **Crecimiento o decrecimiento**:\n   - Si \\(a > 1\\), la función es creciente.\n   - Si \\(0 < a < 1\\), la función es decreciente.\n\n### Relación con la función exponencial:\nLa función logarítmica es la inversa de la función exponencial. Por ejemplo:\n- Si \\(f(x) = e^x\\) es una función exponencial, su inversa es \\(f(x) = \\ln x\\), donde \\(\\ln\\) es el logaritmo natural (base \\(e\\)).\n\n### Ejemplo:\nPara la función \\(f(x) = \\log_2 x\\):\n- Cuando \\(x = 1\\), \\(f(1) = 0\\) porque \\(2^0 = 1\\).\n- Cuando \\(x = 2\\), \\(f(2) = 1\\) porque \\(2^1 = 2\\).\n- Cuando \\(x = 4\\), \\(f(4) = 2\\) porque \\(2^2 = 4\\).\n\n### ¿Te gustaría que te muestre una gráfica interactiva para visualizar cómo se comporta una función logarítmica? 📊\n\n' +
      `¡Listo, Camilo! ✨ Acabo de generar una visualización interactiva para ti.

[GEOGEBRA_VISUALIZATION]Compara una función lineal como f(x) = 2x y una función exponencial como g(x) = 2^x en el mismo plano cartesiano.(https://assets.tenant-ai-1.oneclicklabs.es/visualizations/geogebra/0197f3dd-1404-777e-a522-6ab7d4a1c205.html)[/GEOGEBRA_VISUALIZATION]

En este gráfico, verás dos líneas: una recta y una curva.

La recta representa una función lineal.

La curva representa una función exponencial.

Observa cómo se comportan cada una. ¿Qué diferencias notas en la forma en que crecen? 🤔

¿Cuál de las dos crees que aumenta más rápido a medida que avanzas en el eje de la $x$? 🚀

[THREEJS_VISUALIZATION](ThreeJS Visualización).(https://assets.tenant-ai-1.oneclicklabs.es/visualizations/threejs/0197f3dd-1404-777e-a522-6ab7d4a1c205.html)[/THREEJS_VISUALIZATION]

¡Claro que sí, Fran! Me parece una idea genial para entender mejor cómo funciona la comunicación. 🧠\n\nMira, la **comunicación** es el proceso por el cual transmitimos y recibimos información. En este proceso, siempre participan varios elementos clave.\n\nAquí te dejo un diagrama para que los veas de forma organizada:\n\n\n\n\n[MERMAID_DIAGRAM]mindmap\n  root((Comunicación))\n    Emisor\n      Transmite información\n      Inicia el proceso\n    Receptor\n      Recibe el mensaje\n      Interpreta información\n    Mensaje\n      Contenido transmitido\n      Información principal\n    Canal\n      Medio de transmisión\n      Vía del mensaje\n    Código\n      Sistema de signos\n      Reglas compartidas\n    Contexto\n      Situación temporal\n      Situación espacial\n      Situación sociocultural[/MERMAID_DIAGRAM]En el diagrama puedes ver los **elementos esenciales** para que la comunicación ocurra.\n\n¿Te gustaría que te explique cada uno de estos elementos con más detalle o prefieres que veamos un ejemplo práctico para entenderlos mejor? 🤔\n\n[CONTENT_REFERENCES]\n[{"contentId":"edf27140-4775-11f0-8b1f-97dab0c94886","contentType":"CTTY_05","course":{"id":"292b0f50-477c-11f0-8b1f-97dab0c94886","title":"Edelvives - Lengua 1º ESO"},"unit":{"id":"43f28420-4778-11f0-bf3e-c5334def567e","title":"<p>Unidad 1</p>"},"lesson":{"id":"c0393e70-4778-11f0-8b1f-97dab0c94886","title":"<p>Lecci&oacute;n 1</p>"},"metadata":{"page":11,"position":0},"type":"CONTENT_REFERENCE"},{"contentId":"eec0eb30-477d-11f0-bf3e-c5334def567e","contentType":"CTTY_05","course":{"id":"292b0f50-477c-11f0-8b1f-97dab0c94886","title":"Edelvives - Lengua 1º ESO"},"unit":{"id":"9d4444f0-4778-11f0-bf3e-c5334def567e","title":"<p>Unidad 2</p>"},"lesson":{"id":"61072b00-4779-11f0-8b1f-97dab0c94886","title":"<p>Lecci&oacute;n 4</p>"},"metadata":{"page":29,"position":0},"type":"CONTENT_REFERENCE"},{"contentId":"36363970-720d-11f0-ac3f-5bdd39d3011a","contentType":"MINT","course":{"id":"35a6af30-bb41-11f0-9673-537403b9bed0","title":"Lengua Castellana y Literatura 2"},"unit":{"id":"351d0140-720d-11f0-bd75-3d17c7429249","title":"<p>1. LA COMUNICACIÓN Y LOS TEXTOS</p>"},"lesson":{"id":"36363970-720d-11f0-ac3f-5bdd39d3011a","title":"<p>1. EL TEXTO Y SUS PROPIEDADES</p>"},"metadata":{},"type":"CONTENT_REFERENCE"},{"contentId":"2fe58690-4781-11f0-9881-abd68910bbd5","contentType":"CTTY_05","course":{"id":"292b0f50-477c-11f0-8b1f-97dab0c94886","title":"Edelvives - Lengua 1º ESO"},"unit":{"id":"e61cfef0-4832-11f0-a270-879247bf5018","title":"<p>6. LA LENGUA COMO SISTEMA</p>"},"lesson":{"id":"37ad3f20-4836-11f0-829c-99cbc0353114","title":"<p>Lección 1: La palabra y su segmentación</p>"},"metadata":{"page":67,"position":0},"type":"CONTENT_REFERENCE"},{"contentId":"4aadc990-720d-11f0-bd75-3d17c7429249","contentType":"MINT","course":{"id":"35a6af30-bb41-11f0-9673-537403b9bed0","title":"Lengua Castellana y Literatura 2"},"unit":{"id":"49a3ac90-720d-11f0-ac3f-5bdd39d3011a","title":"<p id=\\"isPasted\\">3. LOS MEDIOS DE COMUNICACIÓN Y LA PUBLICIDAD</p>"},"lesson":{"id":"4aadc990-720d-11f0-bd75-3d17c7429249","title":"<p id=\\"isPasted\\">1. LA SITUACIÓN COMUNICATIVA Y EL REGISTRO EN EL PERIODISMO</p>"},"metadata":{},"type":"CONTENT_REFERENCE"},{"contentId":"414f4220-720d-11f0-bd75-3d17c7429249","contentType":"MINT","course":{"id":"35a6af30-bb41-11f0-9673-537403b9bed0","title":"Lengua Castellana y Literatura 2"},"unit":{"id":"40adf910-720d-11f0-bd75-3d17c7429249","title":"<p id=\\"isPasted\\">2. EL ÁMBITO ACADÉMICO</p>"},"lesson":{"id":"414f4220-720d-11f0-bd75-3d17c7429249","title":"<p>1. SITUACIÓN Y CONTEXTO COMUNICATIVO</p>"},"metadata":{},"type":"CONTENT_REFERENCE"},{"contentId":"41769890-4781-11f0-9e4a-37cfe464ebcb","contentType":"CTTY_05","course":{"id":"292b0f50-477c-11f0-8b1f-97dab0c94886","title":"Edelvives - Lengua 1º ESO"},"unit":{"id":"e1983a20-4832-11f0-829c-99cbc0353114","title":"<p>5. LAS LENGUAS</p>"},"lesson":{"id":"8f72b010-4835-11f0-a270-879247bf5018","title":"<p>Practicar y avanzar</p>"},"metadata":{"page":65,"position":3},"type":"CONTENT_REFERENCE"},{"contentId":"36c419e0-4781-11f0-9e4a-37cfe464ebcb","contentType":"CTTY_05","course":{"id":"292b0f50-477c-11f0-8b1f-97dab0c94886","title":"Edelvives - Lengua 1º ESO"},"unit":{"id":"e1983a20-4832-11f0-829c-99cbc0353114","title":"<p>5. LAS LENGUAS</p>"},"lesson":{"id":"88a337f0-4835-11f0-a270-879247bf5018","title":"<p>Lecci&oacute;n 4: El contacto ling&uuml;&iacute;stico en Espa&ntilde;a</p>"},"metadata":{"page":61,"position":0},"type":"CONTENT_REFERENCE"},{"contentId":"48c32ff0-4781-11f0-9e4a-37cfe464ebcb","contentType":"CTTY_05","course":{"id":"292b0f50-477c-11f0-8b1f-97dab0c94886","title":"Edelvives - Lengua 1º ESO"},"unit":{"id":"e1983a20-4832-11f0-829c-99cbc0353114","title":"<p>5. LAS LENGUAS</p>"},"lesson":{"id":"7cc112e0-4835-11f0-829c-99cbc0353114","title":"<p>Lecci&oacute;n 3: Las lenguas de Espa&ntilde;a</p>"},"metadata":{"page":60,"position":0},"type":"CONTENT_REFERENCE"}]\n[/CONTENT_REFERENCES]

`,
    timestamp: new Date(),
    isStreaming: false,
    context: {
      userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
      currentPage: '/analytics',
      timestamp: new Date().toISOString(),
    },
  },

  // Processing tools activos
  activeToolEvents: [
    {
      id: 'data-analyzer-1647291167010',
      type: 'tool_invocation',
      toolName: 'data_analyzer',
      toolType: 'content_retrieval',
      status: 'started',
      timestamp: new Date().toISOString(),
      description: 'Analizando conjunto de datos...',
      args: { dataSet: 'sales_data_2024.csv' },
      result: null,
    },
    {
      id: 'chart-generator-1647291167011',
      type: 'tool_completion',
      toolName: 'chart_generator',
      toolType: 'd3_visualization',
      status: 'completed',
      timestamp: new Date().toISOString(),
      description: 'Generando visualizaciones...',
      args: { chartType: 'bar', data: 'sales_metrics' },
      result: 'Gráfico generado exitosamente',
    },
    {
      id: 'diagram-builder-1647291167012',
      type: 'tool_invocation',
      toolName: 'diagram_builder',
      toolType: 'mermaid_diagram',
      status: 'started',
      timestamp: new Date().toISOString(),
      description: 'Construyendo diagrama de flujo...',
      args: { diagramType: 'flowchart', elements: ['start', 'process', 'decision'] },
      result: null,
    },
    {
      id: 'report-builder-1647291167013',
      type: 'tool_invocation',
      toolName: 'report_builder',
      toolType: 'content_retrieval',
      status: 'failed',
      timestamp: new Date().toISOString(),
      description: 'Error al generar reporte...',
      args: { reportType: 'summary' },
      result: 'Error: Timeout al acceder a la base de datos',
    },
  ],

  // Estado de conversación
  streamStatus: 'STREAMING',
  isStreaming: true,
};

// 📊 Mock adicional solo para el mensaje con múltiples visualizaciones
export const mockComplexVisualizationMessage = {
  id: 1747291167011,
  sender: 'bot',
  text: `Te muestro un análisis completo con múltiples visualizaciones:

## Diagrama de Arquitectura del Sistema

[MERMAID_DIAGRAM]
graph TB
    subgraph "Frontend"
        A[React App] --> B[Chat (Component)]
        B --> C[Message Parser]
    end
    
    subgraph "Backend"
        D[API Gateway] --> E[Chat Service]
        E --> F[AI Model]
        E --> G[Tool Processor]
    end
    
    C --> D
    G --> H[Database]
[/MERMAID_DIAGRAM]


## Diagrama de Flujo de Datos

[MERMAID_DIAGRAM]
sequenceDiagram
    participant U as Usuario
    participant C as Chat
    participant S as Servidor
    participant AI as IA
    
    U->>C: Envía mensaje
    C->>S: Procesa solicitud
    S->>AI: Consulta IA
    AI-->>S: Respuesta + Tools
    S-->>C: Stream de respuesta
    C-->>U: Muestra resultado
[/MERMAID_DIAGRAM]

Todas estas visualizaciones te ayudarán a entender mejor el flujo del sistema.

[CONTENT_REFERENCES]
[
  {
    "contentId": "f6f7ee50-2cbd-11f0-9d42-8706f8cb603b",
    "course": {
      "id": "f87dc690-2fd4-11f0-a7fa-9bc0752669c1",
      "title": "Demo - Matemáticas 1º ESO"
    },
    "unit": {
      "id": "294ff350-2c1b-11f0-ab64-e3528c9e0c59",
      "title": "<p>1. N&Uacute;MEROS NATURALES</p>"
    },
    "lesson": {
      "id": "6e6aeba0-2c1d-11f0-ab64-e3528c9e0c59",
      "title": "<p>1.4. Multiplicaci&oacute;n y divisi&oacute;n</p>"
    }
  },
  {
    "contentId": "1643b5f0-2cbe-11f0-9d42-8706f8cb603b",
    "course": {
      "id": "f87dc690-2fd4-11f0-a7fa-9bc0752669c1",
      "title": "Demo - Matemáticas 1º ESO"
    },
    "unit": {
      "id": "294ff350-2c1b-11f0-ab64-e3528c9e0c59",
      "title": "<p>1. N&Uacute;MEROS NATURALES</p>"
    },
    "lesson": {
      "id": "7157ab50-2c1d-11f0-ab64-e3528c9e0c59",
      "title": "<p>1.5. Potencias</p>"
    }
  },
  {
    "contentId": "4cceb930-2cbe-11f0-9d42-8706f8cb603b",
    "course": {
      "id": "f87dc690-2fd4-11f0-a7fa-9bc0752669c1",
      "title": "Demo - Matemáticas 1º ESO"
    },
    "unit": {
      "id": "294ff350-2c1b-11f0-ab64-e3528c9e0c59",
      "title": "<p>1. N&Uacute;MEROS NATURALES</p>"
    },
    "lesson": {
      "id": "7bb30950-2c1d-11f0-ab64-e3528c9e0c59",
      "title": "<p>1.7. Operaciones combinadas</p>"
    }
  }
]
[/CONTENT_REFERENCES]`,
  timestamp: new Date(),
  isStreaming: false,
  context: {
    userGuid: '0fcec171-2ce0-11f0-9d42-8706f8cb603b',
    currentPage: '/dashboard',
    timestamp: new Date().toISOString(),
  },
};
